import {Component, Vue} from "vue-property-decorator";
import {mapActions, mapGetters} from "vuex";
import gql from "graphql-tag";
import {AxiosInstance} from "axios";
import {HdsActions} from "@/store/modules/hds/actions";
import {AssetsDataProfile, DataProfile} from "@/store/modules/hcs/dataProfile/model";
import {DataImplementation} from "@/store/modules/hcs/dataImplementation/model";
import {DataComponentModel} from "@/store/modules/hds/Model";

/**
 * データプロファイルと関連する要素のためのビュー
 */
export interface DataProfileView extends DataProfile {
  isAssets: false;
  dataImplementation: DataImplementation;
  commonDataComponentModel: DataComponentModel;
  localDataComponentModel: DataComponentModel;
}

/**
 * 他事業者のデータプロファイルと関連する要素のためのビュー
 */
export interface AssetsDataProfileView extends AssetsDataProfile {
  isAssets: true;
  commonDataComponentModel: DataComponentModel;
}

@Component({
  computed: {
    ...mapGetters({
      _hcsClient: 'hcs/client',
    }),
  },
  methods: {
    ...mapActions({
      _gqlQuery: 'hds/gqlQuery',
    }),
  }
})
export default class extends Vue {
  /** hcs/hcsClient */
  readonly _hcsClient!: AxiosInstance;

  /** hds/gqlQuery */
  readonly _gqlQuery!: HdsActions['gqlQuery'];

  /**
   * データプロファイルを読み込みます
   *
   * @param dataProfileId データプロファイルID
   */
  async loadDataProfile(dataProfileId: string): Promise<DataProfileView> {
    const {data: dataProfile} = await this._hcsClient.get<DataProfile>(`/data_profiles/${dataProfileId}`);
    // const {data: dataImplementation} = await this._hcsClient.get<DataImplementation>(`/data_implementations/${dataProfile.dataImplementationId}`);
    const dataImplementation = dataProfile.dataImplementation;
    const {commonDataComponentModel, localDataComponentModel} = await this._gqlQuery({
        query: gql`
            query FindDataComponentModel(
                $commonDataComponentModelId: ID!,
                $localDataComponentModelId: ID!,
            ) {
                commonDataComponentModel: dataComponentModel(dataComponentModelId: $commonDataComponentModelId) {
                    id
                    name
                    description
                    dictionary {
                        id
                        name
                        description
                    }
                }
                localDataComponentModel: dataComponentModel(dataComponentModelId: $localDataComponentModelId) {
                    id
                    name
                    description
                    dictionary {
                        id
                        name
                        description
                    }
                }
            }`,
      variables: {
        commonDataComponentModelId: dataProfile.dataComponentModelId,
        localDataComponentModelId: dataImplementation?.dataComponentModelId,
      }
    });

    return {
      isAssets: false,
      ...dataProfile,
      // dataImplementation,
      commonDataComponentModel,
      localDataComponentModel
    };
  }

  /**
   * 他事業者のデータプロファイルを読み込みます
   *
   * @param dataProfileId データプロファイルID
   */
  async loadAssetsDataProfile(dataProfileId: string): Promise<AssetsDataProfileView> {
    const {data: dataProfile} = await this._hcsClient.get<AssetsDataProfile>(`/assets/data_profiles/${dataProfileId}`);
    const {commonDataComponentModel} = await this._gqlQuery({
          query: gql`
              query FindDataComponentModel(
                  $commonDataComponentModelId: ID!,
              ) {
                  commonDataComponentModel: dataComponentModel(dataComponentModelId: $commonDataComponentModelId) {
                      id
                      name
                      description
                      dictionary {
                          id
                          name
                          description
                      }
                  }
              }`,
        variables: {
          commonDataComponentModelId: dataProfile.dataComponentModelId
        }
      });

    return {
      isAssets: true,
      ...dataProfile,
      commonDataComponentModel
    };
  }
}
